import { render, staticRenderFns } from "./boxCourse.vue?vue&type=template&id=6385b02c"
import script from "./boxCourse.vue?vue&type=script&lang=js"
export * from "./boxCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports